// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__Mynf5","date-range-label":"Dashboard_date-range-label__MNUkk","stats":"Dashboard_stats__LR+1O","currency-symbol":"Dashboard_currency-symbol__i3Eg2"};